<div class="content-holder" *transloco="let t; scope: 'profile'">
  <div class="header align-items-center">
    <p class="title">
      <span>{{ t('common.name') }}</span>
    </p>
    @if (displayName()) {
      <div class="subtitle">{{ displayName() }}</div>
    }
  </div>

  <div class="row body">
    <div class="col-12 mt-4">
      @if (error()) {
        <alert [type]="'danger'" [dismissible]="true" class="mb-4">
          <span [innerHTML]="t(error()!)"></span>
        </alert>
      }

      @if (initialLoading()) {
        <div class="d-flex justify-content-center py-4">
          <multisite-loader-globe-animation-detail [width]="80" [height]="80" class="my-3"></multisite-loader-globe-animation-detail>
        </div>
      } @else {
        <form [formGroup]="nameForm" role="form" class="w-100" (ngSubmit)="saveName()">
          <div class="input-self">
            <label for="fname" class="form-label">
              {{ t('profile.fname') }}<span class="required-sign">*</span>
            </label>
            <input
              id="fname"
              type="text"
              class="form-control input-lg"
              formControlName="fname"
              autocomplete="given-name"
            />
            <cco-common-form-validation-messages
              [control]="nameForm.controls.fname"
              [showErrors]="submitAttempted()"
            ></cco-common-form-validation-messages>
          </div>

          <div class="input-self">
            <label for="lname" class="form-label">
              {{ t('profile.lname') }}<span class="required-sign">*</span>
            </label>
            <input
              id="lname"
              type="text"
              class="form-control input-lg"
              formControlName="lname"
              autocomplete="family-name"
            />
            <cco-common-form-validation-messages
              [control]="nameForm.controls.lname"
              [showErrors]="submitAttempted()"
            ></cco-common-form-validation-messages>
          </div>

          <div class="input-self">
            <label for="pre_honorific" class="form-label">
              {{ t('profile.pre_honorific') }}
            </label>
            <input
              id="pre_honorific"
              type="text"
              class="form-control input-lg"
              formControlName="pre_honorific"
              autocomplete="honorific-prefix"
            />
            <div class="form-text text-muted">
              {{ t('profile.pre_honorific_help') }}
              {{ t('profile.pre_honorific_help_example') }}
            </div>
            <cco-common-form-validation-messages
              [control]="nameForm.controls.pre_honorific"
              [showErrors]="submitAttempted()"
            ></cco-common-form-validation-messages>
          </div>

          <div class="input-self">
            <label for="post_honorific" class="form-label">
              {{ t('profile.post_honorific') }}
            </label>
            <input
              id="post_honorific"
              type="text"
              class="form-control input-lg"
              formControlName="post_honorific"
              autocomplete="honorific-suffix"
            />
            <div class="form-text text-muted">
              {{ t('profile.post_honorific_help') }}
              {{ t('profile.post_honorific_help_example') }}
            </div>
            <cco-common-form-validation-messages
              [control]="nameForm.controls.post_honorific"
              [showErrors]="submitAttempted()"
            ></cco-common-form-validation-messages>
          </div>

          <div class="input-self">
            <div class="input-group my-3">
              @if (isAnythingLoading()) {
                <div class="d-flex justify-content-center w-100">
                  <multisite-loader-globe-animation-detail [width]="100" [height]="100"></multisite-loader-globe-animation-detail>
                </div>
              } @else {
                 <button
                  class="btn btn-lg btn-primary w-100"
                  type="submit"
                  [disabled]="nameForm.invalid || formDisabled()"
                >
                  {{ t('common.save_changes') }}
                </button>

              }
            </div>
          </div>
        </form>
      }
    </div>
  </div>
</div>